NonEditablePaymentCodesService.SERVICE_NAME = 'nonEditablePaymentCodesService';

export default function NonEditablePaymentCodesService() {
    Object.assign(this, {
        isPerTravellerPaymentCodes,
        formatPerTravellerPaymentCodes,
    });

    function isPerTravellerPaymentCodes(codes) {
        return codes.every((code) => code.TravellerId);
    }

    function formatPerTravellerPaymentCodes(codes, travellers) {
        const travellerIdWithPaymentCodes = Array.from(new Set(codes.map((code) => code.TravellerId)));
        const travellersById = travellers.reduce((acc, traveller) => ({...acc, [traveller.Id]: traveller}), {});
        return travellerIdWithPaymentCodes.map((travellerId) => {
            const traveller = travellersById[travellerId];
            return {
                name: `${traveller.Title.text} ${traveller.FirstName} ${traveller.LastName}`,
                Id: traveller.Id,
                codes: codes.filter((code) => code.TravellerId === traveller.Id),
            };
        });
    }
}



// WEBPACK FOOTER //
// ./src/app/modules/trip/payment-codes/non-editable-payment-codes/non-editable-payment-codes-service.js